import { EventCustomerInjectionWrapper } from '../../Service/InjectionWrapper/EventCustomerInjectionWrapper';
import EmailHistoryListItem from './EmailHistoryListItem';
import { EventCustomerLoadingWrapper } from './EventCustomerLoadingWrapper';

const EmailHistoryList = ({ emails, emailSelected, idOfSelectedEmail, isLoading, event, ...rest }) => {
  const styles = {
    container: { flexGrow: 1 },
    noEmails: {
      marginTop: 100,
      marginBottom: 100,
      fontSize: '0.875rem',
      textAlign: 'center',
      minWidth: 200,
    },
  };

  if (isLoading) {
    return <div style={styles.noEmails}>E-Mails werden geladen...</div>;
  }

  if (emails.length === 0) {
    return <div style={styles.noEmails}>keine Emails</div>;
  }

  return (
    <div style={styles.container}>
      {emails.map((email) => {
        {
          /* if we are in an event, but we're loading an email (cause a participant in on those two events), which is related to another event */
        }
        if (event) {
          if (email && email.eventId && event.id !== email.eventId) {
            return (
              <EventCustomerLoadingWrapper message={email} key={email}>
                <EmailHistoryListItem
                  active={email.id === idOfSelectedEmail}
                  onClick={() => {
                    emailSelected(email);
                  }}
                  {...rest}
                  email={email}
                />
              </EventCustomerLoadingWrapper>
            );
          }
        }

        return (
          <div style={styles.messageList} key={email}>
            {window.location.pathname.includes('/events') && (
              <EventCustomerInjectionWrapper>
                <EmailHistoryListItem
                  active={email.id === idOfSelectedEmail}
                  onClick={() => {
                    emailSelected(email);
                  }}
                  {...rest}
                  email={email}
                />
              </EventCustomerInjectionWrapper>
            )}
            {!window.location.pathname.includes('/events') && (
              <EventCustomerLoadingWrapper message={email}>
                <EmailHistoryListItem
                  active={email.id === idOfSelectedEmail}
                  onClick={() => {
                    emailSelected(email);
                  }}
                  {...rest}
                  email={email}
                />
              </EventCustomerLoadingWrapper>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default EmailHistoryList;
